import { GridComponentConfig } from './gridComponentconfig';
import { Control } from './control';
import { DockItem } from './dockItem';

export class GridConfig {
  constructor(
    public componentClassName?: string,
    public componentConfig?: GridComponentConfig,
    public id?: string,
    public filters?: Object[],
    public parent?: Control,
    public model?: Control,
    public editable?: boolean,
    public hideFilter?: boolean,
    public notClickable?: boolean,
    public addAction?: boolean,
    public editAction?: boolean,
    public deleteAction?: boolean,
  ) { }
}
